import React from 'react';

import { Image, Modal, Upload } from 'antd';

import { Stack } from '@mui/material';

import * as S from '../styles';
import Button from 'components/Button';
import Text from 'components/Text';
import { ImageFallback } from 'utils/imageValidationComponents';

interface UploadModalProps {
  isModalVisible: boolean;
  loading: boolean;
  previewImage: string | null;
  profileImage: string | null;
  handleCancelUpload: () => void;
  handleConfirmUpload: () => void;
  handleUpload: (info: any) => void;
}

const UploadModal: React.FC<UploadModalProps> = ({
  isModalVisible,
  loading,
  previewImage,
  profileImage,
  handleCancelUpload,
  handleConfirmUpload,
  handleUpload,
}) => {
  return (
    <Modal
      open={isModalVisible}
      onCancel={handleCancelUpload}
      closable
      maskClosable
      footer={null}
      width={500}
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
      }}
    >
      {previewImage ? (
        <S.UpdateContainer>
          <Text size="medium" bold>
            PRÉ-VISUALIZAÇÃO:
          </Text>
          <Image
            src={previewImage}
            alt="Preview Image"
            style={{ width: 180, height: 180, borderRadius: '50%' }}
          />
          <Stack direction="row" spacing={2} width="100%">
            <Button variant="outline" onClick={handleCancelUpload} fullWidth>
              Cancelar
            </Button>
            <Button onClick={handleConfirmUpload} loading={loading} fullWidth>
              Confirmar envio
            </Button>
          </Stack>
        </S.UpdateContainer>
      ) : (
        <div style={{ textAlign: 'center', justifyContent: 'center' }}>
          <S.UpdateContainer>
            <Text size="large" color="textPrimary" bold>
              ALTERAR LOGO DA EMPRESA
            </Text>
            {profileImage ? (
              <Image
                src={profileImage}
                alt="Logo da empresa"
                style={{ width: 180, height: 180, borderRadius: '50%' }}
              />
            ) : (
              <ImageFallback size={180} />
            )}
            <S.ButtonsContainer>
              <Upload
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleUpload}
                accept=".jpg,.jpeg,.png,.gif,.bmp,.webp,.tiff,.svg"
              >
                <Button variant="minimal" size="medium" loading={loading}>
                  Carregar novo logo da empresa
                </Button>
              </Upload>
            </S.ButtonsContainer>
          </S.UpdateContainer>
        </div>
      )}
    </Modal>
  );
};

export default UploadModal;
